<template>
  <j-modal
    :title="title"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :maskClosable="false"
    @ok="handleOk"
    :okText="this.$store.getters.language['common.okButton']"
    @cancel="handleCancel"
    :cancelText="language['common.closeButton']"
    wrapClassName="ant-modal-cust-warp"
    style="top:5%;height: 85%;overflow-y: hidden">

    <a-spin :spinning="confirmLoading">
      <a-form-model ref="form"  v-bind="layout"  :model="model" :rules="validatorRules">
        <a-form-model-item

          prop="applicationId"
          :label="language['premission.applicationName']" >
          <a-select
            style="width: 100%"
            allowClear
            :placeholder="language['premission.mustApplication']"
            :disabled="$store.getters.application.applicationType!== 'platform'"
            v-model="model.applicationId"
          >
            <a-select-option v-for="(item,index) in application" :key="index.toString()" :value="item.id">
              {{ item.applicationNameLanguage }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <!--<a-form-model-item label="所属应用" required prop="applicationId">
          <a-input v-model="model.applicationId" :disabled="roleDisabled"  placeholder="请输入角色编码"/>
        </a-form-model-item>-->
        <a-form-model-item :label="language['platform.roleUser.columns.roleCode']" required prop="roleCode">
          <a-input v-model="model.roleCode" :disabled="roleDisabled"  :placeholder="language['platform.roleUser.columns.pleaseSetRoleCode']"/>
        </a-form-model-item>
        <a-form-model-item :label="language['platform.roleUser.columns.roleName']" required prop="roleName">
          <a-input v-model="model.roleName" :placeholder="language['platform.roleUser.columns.pleaseSetRolename']" style="width: 80%"/>
          <a-button @click="roleNameLanguageOpen" type="primary"  style="left: 3%" >{{language['common.language']}}</a-button>
        </a-form-model-item>
        <a-form-model-item :label="language['common.desc']" prop="description">
          <a-textarea :rows="5" v-model="model.description" :placeholder="language['platform.roleUser.columns.pleaseSetRoleDescription']"/>
        </a-form-model-item>
      </a-form-model>
      <language-model ref="languageModel" @ok="languageOk"></language-model>
    </a-spin>
  </j-modal>
</template>

<script>
  import {addRole,editRole,duplicateCheck } from '@/api/api'
  import { getAction, deleteAction, putAction, postAction, httpAction } from '@/api/manage'
  import LanguageModel from "@/components/LanguageModel"
  import DepartTransferModal from "./DepartTransferModal";
  import DepartTransferEmployeeModal from "./DepartTransferEmployeeModal";
  import DepartAuthModal from "./DepartAuthModal";
  import DepartModal from "./DepartModal";
  import StandardDepartModal from "./StandardDepartModal";
  import DepartUploadOrDownloadModal from "./DepartUploadOrDownloadModal";
  export default {
    name: "RoleModal",
    components: {
      LanguageModel,
    },
    data () {
      return {
        application:[{
          id:'',
          applicationName:''
        }],
        title:"",
        visible: false,
        roleDisabled: false,
        model: {},
        layout: {
          labelCol: { span: 5 },
          wrapperCol: { span: 19 },
        },
        confirmLoading: false,

      }
    },
    created () {
      //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
    },
    computed:{
      language() {
        return this.$store.getters.language
      },
      validatorRules(){
        if(this.language){
          return {
            applicationId: [
              { required: true, message: this.language['platform.roleUser.pleaseSetApplication'] }
            ],
            roleName: [
              { required: true, message: this.language['platform.roleUser.pleaseSetRolename']},
              { min: 2, max: 30, message: this.language['platform.roleUser.lengthBetween2and30'], trigger: 'blur' }
            ],
            roleCode: [
              { required: true, message: this.language['platform.roleUser.pleaseSetRoleCode']},
              { min: 0, max: 64, message: this.language['platform.roleUser.lengthNotMore64'], trigger: 'blur' },
              { validator: this.validateRoleCode}
            ],
            description: [
              { min: 0, max: 126, message: this.language['platform.roleUser.lengthNotMore126'], trigger: 'blur' }
            ]
          }
        }
      }
    },
    methods: {
      add () {
        // this.edit(this.modelDefault);
        if(this.$store.getters.application.applicationType!== 'platform'){
          this.edit({applicationId:this.$store.getters.application.id})
        }else{
          this.edit({})
        }
      },
      edit (record) {
        this.getSysBmApplication();
        this.model = Object.assign({}, record);
        this.visible = true;
        //编辑页面禁止修改角色编码
        if(this.model.id){
          this.roleDisabled = true;
          this.initLanguagetemp('SysRole','roleName',this.model.id);
        }else{
          this.roleDisabled = false;
        }
      },
      getSysBmApplication(){
        httpAction("/sys/role/getSysBmApplicationDL", "", "get").then((res) => {
          if (res.success) {
            this.application = res.result;
          }
        })
      },
      close () {
        this.$refs.form.clearValidate();
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let obj;
            if(!this.model.id){
              obj=addRole(this.model);
            }else{
              obj=editRole(this.model);
            }
            obj.then((res)=>{
              if(res.success){
                if(this.model.roleNameLanguages!=undefined) {
                  this.model.roleNameLanguages.forEach(item => {
                    if (!item.dataId) {
                      item.dataId = res.result.id;
                    }
                  })
                  httpAction("/sys/syslanguagedata/saveSysLanguageDataList", this.model.roleNameLanguages, "post").then((res) => {
                    if (res.success) {
                      this.$message.success(this.language['system.savedSuccess'])
                      this.$emit('ok');
                    }
                  })
                }else{
                  this.$message.success(this.language['system.savedSuccess'])
                  this.$emit('ok');
                }

              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }else{
            return false;
          }
        })
      },
      handleCancel () {
        this.close()
      },
      roleNameLanguageOpen(){
        this.languageModelOpen('SysRole','roleName',this.model.id,this.model.roleNameLanguages)
      },
      languageModelOpen(dataTable,dataColumn,dataId,languagelist){
        this.$refs.languageModel.edit("platform",dataTable,dataColumn,dataId,languagelist);
      },
      languageOk(map){
        if(map&&map.dataColumn == 'roleName'){
          this.model.roleNameLanguages = map.languagelist;
        }
      },
      initLanguagetemp(dataTable,dataColumn,dataId){
        getAction("/sys/syslanguagedata/querylistby", {applicationCode:"platform",dataTable:dataTable,dataColumn:dataColumn,dataId:dataId}).then((res)=> {
          if (res.success) {
            // this.checkedDataId = dataId
            this.model.roleNameLanguages = res.result;
          }
        })
      },
      /*validateRoleCode(rule, value, callback){
        if(/[\u4E00-\u9FA5]/g.test(value)){
          callback("角色编码不可输入汉字!");
        }else{
          let params = {
            tableName: "sys_role",
            fieldName: "role_code",
            fieldVal: value,
            dataId: this.model.id,
          };
          duplicateCheck(params).then((res)=>{
            if(res.success){
              callback();
            }else{
              callback(res.message);
            }
          });
        }
      }*/
      validateRoleCode(rule, value, callback){
        if(/[\u4E00-\u9FA5]/g.test(value)){
          callback(this.language['platform.roleUser.roleCodeFormatError']);
        }else{
          let params = {
            id: this.model.id,
            roleCode: value,
            applicationId:this.model.applicationId,
          };
          getAction("/sys/role/checkRoleCodeWhitApplicationId", params).then((res) => {
            if(res !== null && res !== ''){
              if (res.success) {
                callback();
              }else{
                callback(res.message);
              }
            }
          })
          /*duplicateCheck(params).then((res)=>{
            if(res.success){
              callback();
            }else{
              callback(res.message);
            }
          });*/
        }
      }
    }
  }
</script>

<style scoped>

</style>